import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { t } from 'i18next';
import { Button } from '@mui/material';

const AgeSelect = (props) => {
    let loginInfo = props.loginInfo
    let generalOrAI = props.generalOrAI
    let styleOfPainting = props.styleOfPainting
    let to = props.to
    return (
        <>
            <div style={{display:loginInfo.result ? "block" : "none"}}>
                {[{period:"general",name:t("common.general")},{period:"pg12",name:"PG12"},{period:"r15",name:"R15"},{period:"r18",name:"R18"},{period:"r18g",name:"R18G"},{period:"all",name:t("common.all")}].filter(d => {
                  switch(d.period){
                    case "pg12":
                      return loginInfo.pg12_display_flag === 1
                    break
                    case "r15":
                      return loginInfo.r15_display_flag === 1
                    break
                    case "r18":
                      return loginInfo.r18_display_flag === 1
                    break
                    case "r18g":
                      return loginInfo.r18g_display_flag === 1
                    break
                    case "general":
                    case "all":
                      return loginInfo.pg12_display_flag === 1 || loginInfo.r15_display_flag === 1 || loginInfo.r18_display_flag === 1 || loginInfo.r18g_display_flag === 1
                    break
                    default:
                      return true
                  }
                }).map((d,i) => {
                    return <Link to={"/"+to+"/"+styleOfPainting+"/"+d.period} key={i} onClick={() => {
                        if(d.period === "r18" || d.period === "r18g" || d.period === "all"){
                            if(!loginInfo.result){
                                return
                            }
                        }
                        props.onClick()
                    }}><Button variant={(generalOrAI === d.period || (generalOrAI === undefined && d.period === "general") ? "contained" : "")} color='primary' className='m-1'>{d.name}</Button></Link>
                })}
            </div>
        </>
    );
};

export default AgeSelect;